import API from "./index"

export const getBlogs = (page) => API.get(`/blog?page=${page}`)
export const getBlog = (id) => API.get(`/blog/${id}`)
export const createBlog = (data) => API.post(`/blog`, data)
export const deleteBlog = (id) => API.delete(`/blog/${id}`)